import axiosInstance from "../axios/axiosInstance";
import AuthorizationService from "./AuthorizationService";
import config from "./Config";

export default class EmpresaCategoriaService {

    async listCategoriaEmpresas(iss) {
        const accessLevel = AuthorizationService.getResourceAccessLevel('empresa-categoria');

        switch (accessLevel) {
            case 'GLOBAL':
                return this.listAllEmpresaCategoria(iss);
            case 'COMPANY':
                return this.listAllEmpresaCategoriaByCompany(iss);
            case 'SELF':
                return new Error('Acesso não autorizado');
            default:
                throw new Error('Acesso não autorizado');
        }
    }

    listAllEmpresaCategoria(data) {
        return axiosInstance.get(`${config.api.version}/empresa/categoria/${data}/get`)
    }

    listAllEmpresaCategoriaByCompany(data) {
        var params = { all: true }
        return axiosInstance.get(`${config.api.version}/empresa/categoria/${data}/get`, { params: params })
    }

    getEmpresaCategoria(data, id) {
        var params = { all: true }
        return axiosInstance.get(`${config.api.version}/empresa/categoria/${data}/get/${id}`, {
            params: params
        })
    }

    postEmpresaCategoria(data, categoria) {
        return axiosInstance.post(`${config.api.version}/empresa/categoria/${data}/`, categoria, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    }

    putEmpresaCategoria(data, categoria, id) {
        return axiosInstance.put(`${config.api.version}/empresa/categoria/${data}/${id}`, categoria, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    }

    deleteEmpresaCategoria(data, id) {
        return axiosInstance.put(`${config.api.version}/empresa/categoria/${data}/delete/${id}`)
    }
}